import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

/* istanbul ignore next */
const { useCreate: useUserRequestNewPassword } = getCRUDHooks({
  entityName: 'newPasswordRequest',
  create: (email: string) => clientApi.getOCClient().helpers.user.users.requestNewPassword(email),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useUserRequestNewPassword,
};
